/** Labels for hierarchy filters when value is empty (MUI Select display). */

export function renderCircleValue(val, filteredCircles) {
  if (val === "" || val === undefined || val === null) {
    return "All Circle";
  }
  const row = filteredCircles.find(
    (x) => String(x.circleCode) === String(val),
  );
  return row?.circleName ?? String(val);
}

export function renderDivisionValue(val, filteredDivisions) {
  if (val === "" || val === undefined || val === null) {
    return "All Division";
  }
  const row = filteredDivisions.find(
    (x) => String(x.divisionCode) === String(val),
  );
  return row?.divisionName ?? String(val);
}

export function renderSubDivisionValue(val, filteredSubDivisions) {
  if (val === "" || val === undefined || val === null) {
    return "All Sub-Division";
  }
  const row = filteredSubDivisions.find(
    (x) => String(x.subDivisionCode) === String(val),
  );
  return row?.subDivisionName ?? String(val);
}

/** Bill Installments / Due Date Extension category (All, Rejected, Pending, Approved). */
export function renderBillOrDueDateCategoryValue(val) {
  if (val === "" || val === undefined || val === null) {
    return "All";
  }
  const n = Number(val);
  if (Number.isNaN(n)) {
    return String(val);
  }
  const labels = { [-1]: "Rejected", 0: "Pending", 1: "Approved" };
  return labels[n] !== undefined ? labels[n] : String(val);
}

/** Daily / services Progress Report — Category (applicationTypeId) dropdown. */
export const PROGRESS_SERVICE_CATEGORY_LABELS = {
  0: "All",
  1: "New Connections",
  2: "Meter Change Order",
  7: "Due Date Extensions",
  8: "Bill Installments",
  13: "Reconnection",
  15: "Change Of Attributes",
  16: "Last Paid Bill Adjustment",
  17: "Part Payment",
  18: "Advance Payment",
};

export const PROGRESS_SERVICE_CATEGORY_OPTIONS = Object.entries(
  PROGRESS_SERVICE_CATEGORY_LABELS,
)
  .filter(([id]) => id !== "0")
  .map(([id, label]) => ({ id, label }));

export function renderProgressServiceCategoryValue(val) {
  if (val === "" || val === undefined || val === null) {
    return "All";
  }
  const key = typeof val === "string" ? val : String(val);
  const n = Number(key);
  if (!Number.isNaN(n) && PROGRESS_SERVICE_CATEGORY_LABELS[n] !== undefined) {
    return PROGRESS_SERVICE_CATEGORY_LABELS[n];
  }
  return PROGRESS_SERVICE_CATEGORY_LABELS[key] ?? String(val);
}
